// extracted by mini-css-extract-plugin
module.exports = {"noData":"TypeDistributionPanel_noData__05CUf"};